import React from 'react';
import Checkbox from 'material-ui/Checkbox';
import ReorderIcon from 'material-ui/svg-icons/action/reorder';
import TrashIcon from 'components/pure/utils/icon/TrashIcon';
import SkillsSelectField from '$pages/@common/skills-field';
import TextAreaField from 'components/pure/utils/form/TextAreaField';
import get from 'lodash/get';
import {validate} from 'records/Question';
import FieldContainer from 'components/pure/utils/form/FieldContainer';
import './QuestionForm.styl';
import ReasonSelectFieldContainer from 'components/pure/admin/ReasonSelectFieldContainer';
import {CREATE_NEW, NONE} from 'components/pure/admin/QuestionForm.const';

export default class QuestionForm extends React.PureComponent {
  constructor(props) {
    super(props);
    this.onDragStart = this.onDragStart.bind(this);
    this.onDrop = this.onDrop.bind(this);
    this.onDelete = this.onDelete.bind(this);
    this.onSkillChange = this.onSkillChange.bind(this);
    this.onReasonSchemeChange = this.onReasonSchemeChange.bind(this);
  }

  onDragStart(e) {
    // Firefox requires that you set something to the dataTransfer object
    // otherwise dragging simply won't work.  Very strange api requirement..
    // See https://stackoverflow.com/a/19055350
    e.dataTransfer.setData('text', 'anything');
    e.dataTransfer.setDragImage(this.ref, 0, 0);
    e.dataTransfer.effectAllowed = 'move';
    this.props.onDragStart(this.props.index);
  }

  onDragOver(e) {
    e.preventDefault();
  }

  onDrop(e) {
    if (e.dataTransfer.effectAllowed === 'move') {
      e.preventDefault();
      e.dataTransfer.dropEffect = 'move';
      this.props.onDrop(this.props.index);
    }
  }

  onChange(field, value) {
    this.props.onChange(this.props.index, this.props.question.set(field, value));
  }

  onDelete() {
    this.props.onDelete(this.props.index);
  }

  onSkillChange(value) {
    this.onChange('skills', value);
  }

  onReasonSchemeChange(value) {
    if (value === CREATE_NEW) {
      this.props.showNewReasonSchemeForm();
      this.onChange('reasonScheme', null);
    } else if (value === NONE) {
      this.onChange('reasonScheme', null);
    } else {
      this.onChange('reasonScheme', value);
    }
  }

  render() {
    const {question} = this.props;
    const errors = validate(question);

    return (
      <tr
        className="question-form"
        ref={ref => (this.ref = ref)}
        onDragOver={this.onDragOver}
        onDrop={this.onDrop}>
        <td>
          <div className="question-number">
            <div className="drag-handle" draggable="true" onDragStart={this.onDragStart}>
              <ReorderIcon />
            </div>
            {this.props.index + 1}
          </div>
        </td>
        <td>
          <FieldContainer errorOnBlur={true} error={get(errors, 'text[0]')}>
            <TextAreaField
              value={question.text || ''}
              onChange={value => this.onChange('text', value)}
              rows="1"
              placeholder="Type a question..."
              inputRef={this.props.inputRef}
            />
          </FieldContainer>
        </td>
        <td>
          <FieldContainer>
            <SkillsSelectField value={question.skills} onChange={this.onSkillChange} />
          </FieldContainer>
        </td>
        <td>
          <Checkbox
            checked={question.allowComments}
            onCheck={() => this.onChange('allowComments', !question.allowComments)}
          />
        </td>
        <td className="reasons">
          <FieldContainer>
            <ReasonSelectFieldContainer
              value={question.reasonScheme}
              onChange={this.onReasonSchemeChange}
            />
          </FieldContainer>
        </td>
        <td>
          <TrashIcon onClick={this.onDelete} />
        </td>
      </tr>
    );
  }
}
